import { ApiError } from '../api/client';
import { useAuth } from '../auth/AuthProvider';
import { useAppConfig } from '../configContext';
import { strings } from '../strings';
import { Icon } from './Icon';

/** Plain-language explanation of a failed request, with the one action that helps. */
export function ErrorPanel({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const { signOut } = useAuth();
  const { supportContact } = useAppConfig();
  const kind = error instanceof ApiError ? error.kind : 'server';

  const message =
    kind === 'unauthorized'
      ? strings.errors.sessionExpired
      : kind === 'forbidden'
        ? strings.errors.forbidden(supportContact)
        : kind === 'notFound'
          ? strings.errors.notFound
          : kind === 'network'
            ? strings.errors.network
            : strings.errors.generic;

  return (
    <div role="alert" className="flex gap-3 border-l-4 border-status-error bg-white p-4">
      <Icon name="errorWarning" className="mt-1 h-6 w-6 text-brand-magenta" />
      <div>
        <p className="m-0 font-bold">{strings.errors.title}</p>
        <p className="m-0 mt-1">{message}</p>
        {kind === 'unauthorized' ? (
          <button type="button" className="btn-primary mt-3" onClick={() => void signOut()}>
            {strings.errors.signInAgain}
          </button>
        ) : (
          onRetry &&
          (kind === 'network' || kind === 'server') && (
            <button type="button" className="btn-secondary mt-3" onClick={onRetry}>
              {strings.errors.retry}
            </button>
          )
        )}
      </div>
    </div>
  );
}

export function Loading() {
  return (
    <p role="status" className="text-neutral-muted">
      {strings.loading}
    </p>
  );
}
